import { Icon } from '@chakra-ui/react';
import {
  Md3DRotation,
  MdAddHomeWork,
  MdArchive,
  MdCalculate,
  MdDashboard,
  MdDirections,
  MdDirectionsOff,
  MdEditDocument,
  MdHome,
  MdLock,
  MdLogin,
  MdMoney,
  MdOutlineShoppingCart,
  MdPriceCheck,
  MdSettings,
  MdViewAgenda,
  MdWash,
  MdWork,
} from 'react-icons/md';

// Admin Imports
import DashboardsDefault from 'views/admin/dashboards/default';
//import DashboardsRTLDefault from 'views/admin/dashboards/rtl';
import Secciones from 'views/admin/dashboards/secciones';
import DashboardsSmartHome from 'views/admin/dashboards/smartHome';

// // NFT Imports
import NFTMarketplace from 'views/admin/nfts/marketplace';
import NFTPage from 'views/admin/nfts/page';
import NFTCollection from 'views/admin/nfts/collection';
import NFTProfile from 'views/admin/nfts/profile';

// Main Imports
import AccountBilling from 'views/admin/main/account/billing';
import AccountApplications from 'views/admin/main/account/application';
import AccountInvoice from 'views/admin/main/account/invoice';
import AccountSettings from 'views/admin/main/account/settings';
import AccountAllCourses from 'views/admin/main/account/courses';
import AccountCoursePage from 'views/admin/main/account/coursePage';

import UserNew from 'views/admin/main/users/newUser';
import UsersOverview from 'views/admin/main/users/overview';
import UsersReports from 'views/admin/main/users/reports';

import ProfileSettings from 'views/admin/main/profile/settings';
import ProfileOverview from 'views/admin/main/profile/overview';
import ProfileNewsfeed from 'views/admin/main/profile/newsfeed';

import ApplicationsKanban from 'views/admin/main/applications/kanban';
import ApplicationsDataTables from 'views/admin/main/applications/dataTables';
import ApplicationsCalendar from 'views/admin/main/applications/calendar';

import EcommerceNewProduct from 'views/admin/main/ecommerce/newProduct';
import EcommerceProductOverview from 'views/admin/main/ecommerce/overviewProduct';
import EcommerceProductSettings from 'views/admin/main/ecommerce/settingsProduct';
import EcommerceProductPage from 'views/admin/main/ecommerce/pageProduct';
import EcommerceOrderList from 'views/admin/main/ecommerce/orderList';
import ProductosLista from 'views/admin/main/ecommerce/productoslista';
import EcommerceOrderDetails from 'views/admin/main/ecommerce/orderDetails';
import EcommerceReferrals from 'views/admin/main/ecommerce/referrals';

// Others
import OthersNotifications from 'views/admin/main/others/notifications';
import OthersPricing from 'views/admin/main/others/pricing';
import OthersError from 'views/admin/main/others/404';
import Messages from 'views/admin/main/others/messages';

// Auth Imports
import ForgotPasswordCentered from 'views/auth/forgotPassword/ForgotPasswordCentered';
import ForgotPasswordDefault from 'views/auth/forgotPassword/ForgotPasswordDefault';
import LockCentered from 'views/auth/lock/LockCentered';
import LockDefault from 'views/auth/lock/LockDefault';
import SignInCentered from 'views/auth/signIn/SignInCentered';
import SignInDefault from 'views/auth/signIn/SignInDefault';
import SignUpCentered from 'views/auth/signUp/SignUpCentered';
import SignUpDefault from 'views/auth/signUp/SignUpDefault';
import VerificationCentered from 'views/auth/verification/VerificationCentered';
import VerificationDefault from 'views/auth/verification/VerificationDefault';
/////// OBS

import ListaLocales from 'views/admin/main/ecommerce/Locales';
import ListaUsuarios from 'views/admin/main/ecommerce/Usuarios';

import NuevoLocal from 'views/admin/main/ecommerce/NuevoLocal';
import NuevoUsuario from 'views/admin/main/ecommerce/NuevoUsuario';


// VISITANTES

import NuevoVotante from 'views/admin/main/ERP/Votantes/NuevoVotante';
import RegistrosVotantes from 'views/admin/main/ERP/Votantes/RegistrosVotantes';

//  CANDIDATO 
import NuevoCandidato from 'views/admin/main/ERP/Candidatos/NuevoCandidato';
import RegistroCandidato from 'views/admin/main/ERP/Candidatos/RegistroCandidato';

//  CANDIDATO 
import NuevaEncuesta from 'views/admin/main/ERP/Candidatos/NuevaEncuesta';
import RegistroEncuesta from 'views/admin/main/ERP/Candidatos/RegistroEncuesta';

import Encuestas from 'views/admin/main/ERP/Candidatos/Encuestas';

//  Administradores 
import NuevoAdmin from 'views/admin/main/ERP/Usuarios/NuevoAdmin';
import RegistroAdmin from 'views/admin/main/ERP/Usuarios/RegistroAdmin';


//personal
import NuevoPersonal from 'views/admin/main/ERP/Personal/NuevoPersonal';
import RegistroPersonal from 'views/admin/main/ERP/Personal/RegistroPersonal';




// CLIENTES

import NuevoCliente from 'views/admin/main/ERP/Clientes/NuevoCliente';
import RegistrosCliente from 'views/admin/main/ERP/Clientes/RegistrosCliente';



// PROVEEDOR

import NuevoProveedor from 'views/admin/main/ERP/Proveedores/NuevoProveedor';
import RegistroProveedor from 'views/admin/main/ERP/Proveedores/RegistroProveedores';

// COMPRAS

import NuevaCompra from 'views/admin/main/ERP/Compras/NuevaCompra';
import RegistrosCompras from 'views/admin/main/ERP/Compras/RegistrosCompras';


// VENTAS
import NuevaVenta from 'views/admin/main/ERP/Ventas/NuevaVenta';
import RegistrosVentas from 'views/admin/main/ERP/Ventas/RegistrosVentas';
//INGRESOS 

import NuevoIngreso from 'views/admin/main/ERP/Ingresos/NuevoIngreso';
import RegistrosIngresos from 'views/admin/main/ERP/Ingresos/RegistrosIngresos';

// AGENDA DE ACTIVIDADES


import NuevaActividad from 'views/admin/main/ERP/AgendaActividades/NuevaActividad';
import RegistroActividades from 'views/admin/main/ERP/AgendaActividades/RegistroActividades';
import Album from 'views/admin/main/ERP/AgendaActividades/Album';

// Configuracion 

import AjustePositivo from 'views/admin/main/ERP/Configuracion/AjustePositivo';
import AjusteNegativo from 'views/admin/main/ERP/Configuracion/AjusteNegativo';
import CargaInicial from 'views/admin/main/ERP/Configuracion/CargaInicial';
import Notificaciones from 'views/admin/main/ERP/Configuracion/Notificaciones';

//Supervisores
import NuevoSuper from 'views/admin/main/ERP/Supervisores/NuevoPersonal';
import RegistroSuper from 'views/admin/main/ERP/Supervisores/RegistroPersonal';

//import RegistrosIngresos from 'views/admin/main/ERP/Ingresos/RegistrosIngresos';

//AYUNTAMIENTO PROVISIONAL

import PlanDeTrabajoPresidencia from 'views/PlanDeTrabajoPresidencia'
import AgendaPresidencia from 'views/AgendaPresidencia'
import AtencionCiudadanaPresidencia from 'views/AtencionCiudadanaPresidencia'
import InformeDeActividadesPresidencia from 'views/InformeDeActividadesPresidencia'
import GestionJuridicaLegalSindico from 'views/GestionJuridicaLegalSindico';
import Login from 'views/Login';
import GestionContratacionesLicitacionesSindico from 'views/GestionContratacionesLicitacionesSindico';
import TransparenciaRendicionCuentasSindico from 'views/TransparenciaRendicionCuentasSindico';
import GestionDocumentacionLegalSindico from 'views/GestionDocumentacionLegalSindico';
import GestionDocumentosCorrespondenciaSecretarioGeneral from 'views/GestionDocumentosCorrespondenciaSecretarioGeneral';
import ActasMinutasSecretarioGeneral from 'views/ActasMinutasSecretarioGeneral.tsx';
import AtencionGestionSolicitudesCiudadanasSecretarioGeneral from 'views/AtencionGestionSolicitudesCiudadanasSecretarioGeneral';
import ControlDocumentacionLegalAdministrativaSecretarioGeneral from 'views/ControlDocumentacionLegalAdministrativaSecretarioGeneral';
import PlanificacionSeguimientoProyectosSecretarioGeneral from 'views/PlanificacionSeguimientoProyectosSecretarioGeneral';
import SeguridadControlAccesoSecretarioGeneral from 'views/SeguridadControlAccesoSecretarioGeneral';
import GestionRecursosHumanosSecretarioGeneral from 'views/GestionRecursosHumanosSecretarioGeneral';
import AuditoriaInternaContraloria from 'views/AuditoriaInternaContraloria';
import ControlFinanzasPresupuestoContraloria from 'views/ControlFinanzasPresupuestoContraloria';
import CumplimientoNormativoContraloria from 'views/CumplimientoNormativoContraloria';
import GestionContratacionesLicitacionesContraloria from 'views/GestionContratacionesLicitacionesContraloria';
import AtencionQuejasDenunciasContraloria from 'views/AtencionQuejasDenunciasContraloria';
import ControlProcedimientosAdministrativosContraloria from 'views/ControlProcedimientosAdministrativosContraloria';
import GestionDocumentacionRegistrosContraloria from 'views/GestionDocumentacionRegistrosContraloria';
import { IoMdGlobe } from 'react-icons/io';
import ContabilidadTesoreria from 'views/ContabilidadTesoreria';
import PredialTesoreria from 'views/PredialTesoreria';
import { FaBalanceScale, FaFaucet, FaFileInvoice, FaMap, FaMapPin, FaMoneyBillWave, FaPiggyBank, FaTape, FaTimes, FaUserAstronaut, FaWater } from 'react-icons/fa';
import { FiClipboard, FiUsers, FiFileText, FiEye, FiFile, FiInbox, FiUserCheck, FiBarChart2, FiShield, FiDollarSign, FiCheckCircle, FiAlertCircle, FiPieChart, FiTrendingUp, FiBriefcase, FiPackage } from 'react-icons/fi';
import Catalogos from 'views/Catalogos/CatalogosIndex';
import Transacciones from 'views/TransaccionesX/Transacciones';
import TransaccionesCajaGral from 'views/CajaGeneral/TransaccionesCajaGral';
import TarifaServiciosCatalogo from 'views/Tarifas/TarifasIndex';
import CajaAguaPotable from 'views/AguaPotable/CajaAguaPotable';
import CFacturados from 'views/CFacturados/CFacturados';

import PropietarioTesoreria from 'views/PropietariosTesoreria';
import PadronCiudadano from 'views/PadronCiudadano';
import UsuarioManagement from 'views/Usuarios/UsuarioIndex';
import TurnosIndex from 'views/Turnos/TurnosIndex';
import { BsBank } from 'react-icons/bs';
import PortalLogin from 'views/PortalCiudadano/PortalLogin';

const routes = [
  {
    name: 'Mis Tramites',
    path: '/tramites',
    icon: <Icon as={IoMdGlobe} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
   
      {
        name: 'Licencias',
        layout: '/admin',
        perfil: 'admin',
        path: '/comerciales',
        icon: <Icon as={MdWork} width="20px" height="20px" color="inherit" />,
        component: <PortalLogin />,
      },

      {
        name: 'Predios',
        layout: '/admin',
        perfil: 'admin',
        path: '/predios',
        icon: <Icon as={MdAddHomeWork} width="20px" height="20px" color="inherit" />,
        component: <PortalLogin />,
      },

      {
        name: 'Agua Potable',
        layout: '/admin',
        perfil: 'admin',
        path: '/agua-potable',
        icon: <Icon as={MdWash} width="20px" height="20px" color="inherit" />,
        component: <PortalLogin />,
      },

      {
        name: 'Multas',
        layout: '/admin',
        perfil: 'admin',
        path: '/multas',
        icon: <Icon as={MdCalculate} width="20px" height="20px" color="inherit" />,
        component: <PortalLogin />,
      },
    
    ],
  },
  {
    name: 'Presidencia',
    path: '/Presidencia',
    icon: <Icon as={IoMdGlobe} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
   
      {
        name: 'Plan de trabajo',
        layout: '/admin',
        perfil: 'admin',
        path: '/plan-de-trabajo',
        icon: <Icon as={MdEditDocument} width="20px" height="20px" color="inherit" />,
        component: <PlanDeTrabajoPresidencia />,
      },
      // {
      //   name: 'Agenda',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/agenda',
      //   icon: <Icon as={MdViewAgenda} width="20px" height="20px" color="inherit" />,
      //   component: <AgendaPresidencia />,
      // },
      // {
      //   name: 'Informe de Actividades',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/informe-de-actividades',
      //   icon: <Icon as={FiClipboard} width="20px" height="20px" color="inherit" />,
      //   component: <InformeDeActividadesPresidencia />,
      // },
      // {
      //   name: 'Atención ciudadana',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/atencion-ciudadana',
      //   icon: <Icon as={FiUsers} width="20px" height="20px" color="inherit" />,
      //   component: <AtencionCiudadanaPresidencia />,
      // },
    ],
  },
  // {
  //   name: 'Inicio de Sesion',
  //   path: '/login',
  //   icon: <Icon as={MdLogin} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Inicio de Sesion',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/login',
  //       icon: <Icon as={FaBalanceScale} width="20px" height="20px" color="inherit" />,
  //       component: <Login />,
  //     },
  //   ]
  // },
  // {
  //   name: 'Sindico',
  //   path: '/Sindico',
  //   icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Gestión jurídica y legal',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/gestion-juridica-legal',
  //       icon: <Icon as={FaBalanceScale} width="20px" height="20px" color="inherit" />,
  //       component: <GestionJuridicaLegalSindico />,
  //     },
  //     {
  //       name: 'Gestión de Contrataciones y Licitaciones',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/gestion-contrataciones-licitaciones',
  //       icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
  //       component: <GestionContratacionesLicitacionesSindico />,
  //     },
  //     {
  //       name: 'Transparencia y Rendición de Cuentas',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/transparencia-rendicion-cuentas',
  //       icon: <Icon as={FiEye} width="20px" height="20px" color="inherit" />,
  //       component: <TransparenciaRendicionCuentasSindico />,
  //     },
  //     {
  //       name: 'Gestión de Documentación Legal',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/gestion-documentacion-legal',
  //       icon: <Icon as={FiFile} width="20px" height="20px" color="inherit" />,
  //       component: <GestionDocumentacionLegalSindico />,
  //     },
  //   ],
  // },
  // {
  //   name: 'Secretario General',
  //   path: '/SecreGeneral',
  //   icon: <Icon as={MdDirections} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Gestión de Documentos y Correspondencia',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       secondary: true,
  //       path: '/gestion-documentos-correspondencia',
  //       icon: <Icon as={FiInbox} width="20px" height="20px" color="inherit" />,
  //       component: <GestionDocumentosCorrespondenciaSecretarioGeneral />,
  //     },
  //     {
  //       name: 'Actas y Minutas',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/actas-minutas',
  //       icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
  //       component: <ActasMinutasSecretarioGeneral />,
  //     },
  //     {
  //       name: 'Gestión de Recursos Humanos',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/gestion-recursos-humanos',
  //       icon: <Icon as={FiUserCheck} width="20px" height="20px" color="inherit" />,
  //       component: <GestionRecursosHumanosSecretarioGeneral />,
  //     },
  //     {
  //       name: 'Control de Documentación Legal y Administrativa',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/control-documentacion-legal-administrativa',
  //       icon: <Icon as={FiFile} width="20px" height="20px" color="inherit" />,
  //       component: <ControlDocumentacionLegalAdministrativaSecretarioGeneral />,
  //     },
  //     {
  //       name: 'Planificación y Seguimiento de Proyectos',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/planificacion-seguimiento-proyectos',
  //       icon: <Icon as={FiBarChart2} width="20px" height="20px" color="inherit" />,
  //       component: <PlanificacionSeguimientoProyectosSecretarioGeneral />,
  //     },
  //     {
  //       name: 'Atención y Gestión de Solicitudes Ciudadanas',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/atencion-gestion-solicitudes-ciudadanas',
  //       icon: <Icon as={FiUsers} width="20px" height="20px" color="inherit" />,
  //       component: <AtencionGestionSolicitudesCiudadanasSecretarioGeneral />,
  //     },
  //     {
  //       name: 'Seguridad y Control de Acceso',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/seguridad-control-acceso',
  //       icon: <Icon as={FiShield} width="20px" height="20px" color="inherit" />,
  //       component: <SeguridadControlAccesoSecretarioGeneral />,
  //     },
  //   ],
  // },
  // {
  //   name: 'Contraloria',
  //   path: '/Contraloria',
  //   icon: <Icon as={MdCalculate} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Auditoría Interna Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/auditoria-interna',
  //       icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
  //       component: <AuditoriaInternaContraloria />,
  //     },
  //     {
  //       name: 'Control de Finanzas y Presupuesto Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/control-finanzas-presupuesto',
  //       icon: <Icon as={FiDollarSign} width="20px" height="20px" color="inherit" />,
  //       component: <ControlFinanzasPresupuestoContraloria />,
  //     },
  //     {
  //       name: 'Gestión de Contrataciones y Licitaciones Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/gestion-contrataciones-licitaciones',
  //       icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
  //       component: <GestionContratacionesLicitacionesContraloria />,
  //     },
  //     {
  //       name: 'Cumplimiento Normativo Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/cumplimiento-normativo',
  //       icon: <Icon as={FiCheckCircle} width="20px" height="20px" color="inherit" />,
  //       component: <CumplimientoNormativoContraloria />,
  //     },
  //     {
  //       name: 'Atención de Quejas y Denuncias Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/atencion-quejas-denuncias',
  //       icon: <Icon as={FiAlertCircle} width="20px" height="20px" color="inherit" />,
  //       component: <AtencionQuejasDenunciasContraloria />,
  //     },
  //     {
  //       name: 'Control de Procedimientos Administrativos Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/control-procedimientos-administrativos',
  //       icon: <Icon as={FiClipboard} width="20px" height="20px" color="inherit" />,
  //       component: <ControlProcedimientosAdministrativosContraloria />,
  //     },
  //     {
  //       name: 'Gestión de Documentación y Registros Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/gestion-documentacion-registros',
  //       icon: <Icon as={FiFile} width="20px" height="20px" color="inherit" />,
  //       component: <GestionDocumentacionRegistrosContraloria />,
  //     },
  //   ],
  // },
  // {
  //   name: 'Catalogos',
  //   path: '/Catalogos',
  //   icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
    
    
  //     {
  //       name: 'Catalogo',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/Catalogos/catalogo',
  //       icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
  //       component: <Catalogos />,
  //     },]}
      
  //     ,
      {
        
    name: 'Sistema',
    path: '/Sistema',
    icon: <Icon as={MdSettings
  
    } width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
     
      {
        name: 'Usuarios',
        layout: '/admin',
        perfil: 'admin',
        path: '/sistema/usuarios',
        icon: <Icon as={FaUserAstronaut} width="20px" height="20px" color="inherit" />,
        component: <UsuarioManagement />,
      },
      {
        name: 'Turnos',
        layout: '/admin',
        perfil: 'admin',
        path: '/sistema/turnos',
        icon: <Icon as={FaTimes} width="20px" height="20px" color="inherit" />,
        component: <TurnosIndex />,
      },
      // {
      //   name: 'Sesiones Iniciadas',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/sistema/s_iniciadas',
      //   icon: <Icon as={FaUserAstronaut} width="20px" height="20px" color="inherit" />,
      //   component: <UsuarioManagement />,
      // },
      // {
      //   name: 'Registro de Acciones',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/sistema/r_acciones',
      //   icon: <Icon as={FaUserAstronaut} width="20px" height="20px" color="inherit" />,
      //   component: <UsuarioManagement />,
      // }
    ]
      },
  {
    name: 'Tesoreria',
    path: '/Tesoreria',
    icon: <Icon as={MdMoney} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Propietarios',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/propietarios',
        icon: <Icon as={FiUsers} width="20px" height="20px" color="inherit" />,
        component: <PropietarioTesoreria />,
      },

      {
        name: 'Padron de Ciudadanos',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/ciudadanos',
        icon: <Icon as={FaUserAstronaut} width="20px" height="20px" color="inherit" />,
        component: <PadronCiudadano />,
      },
      {
        name: 'Predios',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/predios',
        icon: <Icon as={FaMapPin} width="20px" height="20px" color="inherit" />,
        component: <PredialTesoreria />,
      },
      {
        name: 'Transacciones de Caja General',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/transaccionescgeneral',
        icon: <Icon as={FaPiggyBank} width="20px" height="20px" color="inherit" />,
        component: <TransaccionesCajaGral />,
      },
      {
        name: 'Agua Potable',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/AguaPotable',
        icon: <Icon as={FaFaucet} width="20px" height="20px" color="inherit" />,
        component: <CajaAguaPotable />,
      },
      {
        name: 'Conceptos Facturados',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/CFacturados',
        icon: <Icon as={FaFileInvoice} width="20px" height="20px" color="inherit" />,
        component: <CFacturados />,
      },
      {
        name: 'Transacciones de Predio',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/transacciones',
        icon: <Icon as={BsBank} width="20px" height="20px" color="inherit" />,
        component: <Transacciones />,
      },

      {
        name: 'Detalles de Recaudacion',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/recaudacion',
        icon: <Icon as={FaMoneyBillWave} width="20px" height="20px" color="inherit" />,
        component: <CFacturados />,
      },
     
    //   {
    //     name: 'Tarifas',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/tarifas',
    //     icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
    //     component: <TarifaServiciosCatalogo />,
    //   },
    //   {
    //     name: 'Recursos Humanos',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/recursos-humanos',
    //     icon: <Icon as={FiUserCheck} width="20px" height="20px" color="inherit" />,
    //   //  component: <RecursosHumanosTesoreria />,
    //   },
    //   {
    //     name: 'Reportes y Análisis Financiero',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/reportes-analisis-financiero',
    //     icon: <Icon as={FiBarChart2} width="20px" height="20px" color="inherit" />,
    //  //   component: <ReportesAnalisisFinancieroTesoreria />,
    //   },
    //   {
    //     name: 'Control de Deuda',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/control-deuda',
    //     icon: <Icon as={FiDollarSign} width="20px" height="20px" color="inherit" />,
    //   //  component: <ControlDeudaTesoreria />,
    //   },
    //   {
    //     name: 'Gestión de Inversiones',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/gestion-inversiones',
    //     icon: <Icon as={FiTrendingUp} width="20px" height="20px" color="inherit" />,
    //   //  component: <GestionInversionesTesoreria />,
    //   },
    //   {
    //     name: 'Gestión de Subsidios y Subvenciones',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/gestion-subsidios-subvenciones',
    //     icon: <Icon as={FiBriefcase} width="20px" height="20px" color="inherit" />,
    //  //   component: <GestionSubsidiosSubvencionesTesoreria />,
    //   },
    //   {
    //     name: 'Gestión de Activos Fijos',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/gestion-activos-fijos',
    //     icon: <Icon as={FiPackage} width="20px" height="20px" color="inherit" />,
    //    // component: <GestionActivosFijosTesoreria />,
    //   },
    //   {
    //     name: 'Control de Contratos y Pagos',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/control-contratos-pagos',
    //     icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
    //  //   component: <ControlContratosPagosTesoreria />,
    //   },
    //   {
    //     name: 'Gestión de Impuestos y Contribuciones',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/gestion-impuestos-contribuciones',
    //     icon: <Icon as={FiDollarSign} width="20px" height="20px" color="inherit" />,
    //   //  component: <GestionImpuestosContribucionesTesoreria />,
    //   },
    ],
  },
  
  // --- NFTs ---
  // {
  //   name: 'NFTs',
  //   path: '/nfts',
  //   icon: (
  //     <Icon
  //       as={MdOutlineShoppingCart}
  //       width="20px"
  //       height="20px"
  //       color="inherit"
  //     />
  //   ),
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Marketplace',
  //       layout: '/rtl',
  //       path: '/nfts/marketplace',
  //       component: <NFTMarketplace />,
  //       secondary: true,
  //     },
  //   ],
  // },
  // // --- Main pages ---

  // {
  //   name: 'Votos',
  //   path: '/comitiva',
  //   icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Votantes',
  //       path: '/main/ERP/Votantes',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Votos Promovidos',
  //           layout: '/comitiva',
  //           path: '/main/ERP/Votantes/NuevoVotante',
  //           exact: false,
  //           component: <NuevoVotante />,
  //         }, {
  //           name: 'Registro de Votos Promovidos',
  //           layout: '/comitiva',
  //           path: '/main/ERP/Votantes/RegistrosVotantes',
  //           exact: false,
  //           // component: <EcommerceOrderList />,
  //           component: <RegistrosVotantes />,
  //         },
  //       ]
  //     }]
  // },

  // {
  //   name: 'Sistema',
  //   path: '/main',
  //   icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Candidatos',
  //       path: '/main/ERP/Candidatos',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nuevo Candidato',
  //           layout: '/admin',
  //           path: '/main/ERP/Candidatos/NuevoCandidato',
  //           exact: false,
  //           component: <NuevoCandidato />,
  //         }, {
  //           name: 'Registro de Candidatos',
  //           layout: '/admin',
  //           path: '/main/ERP/Candidatos/RegistroCandidato',
  //           exact: false,
  //           component: <RegistroCandidato />,
  //         },
  //         {
  //           name: 'Nueva Encuesta',
  //           layout: '/admin',
  //           path: '/main/ERP/Candidatos/NuevaEncuesta',
  //           exact: false,
  //           component: <NuevaEncuesta />,
  //         }, {
  //           name: 'Registro de Encuestas',
  //           layout: '/admin',
  //           path: '/main/ERP/Candidatos/RegistroEncuesta',
  //           exact: false,
  //           component: <RegistroEncuesta />,
  //         }
        
  //       ]
  //     },
   
  //     {
  //       name: 'Supervisores',
  //       path: '/main/ERP/Personal/NuevoPersonal',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nuevo Supervisor',
  //           layout: '/admin',
  //           path: '/main/ERP/Super/NuevoSuper',
  //           exact: false,
  //           component: <NuevoSuper />,
  //         }, {
  //           name: 'Registro de Supervisor',
  //           layout: '/admin',
  //           path: '/main/ERP/Super/RegistroSuper',
  //           exact: false,
  //           component: <RegistroSuper />,
  //         },
  //       ]
  //     },


  //     {
  //       name: 'Administradores',
  //       path: '/main/ERP/Usuarios/NuevoAdmin',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nuevo Administrador',
  //           layout: '/admin',
  //           path: '/main/ERP/Usuarios/NuevoAdmin',
  //           exact: false,
  //           component: <NuevoAdmin />,
  //         }, {
  //           name: 'Registro de Administradores',
  //           layout: '/admin',
  //           path: '/main/ERP/Usuarios/RegistroAdmin',
  //           exact: false,
  //           component: <RegistroAdmin />,
  //         },
        
  //       ]
  //     },

  //     {
  //       name: 'Mi Personal',
  //       path: '/main/ERP/Personal/NuevoPersonal',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nuevo Personal',
  //           layout: '/admin',
  //           path: '/main/ERP/Personal/NuevoPersonal',
  //           exact: false,
  //           component: <NuevoPersonal />,
  //         }, {
  //           name: 'Registro de Personal',
  //           layout: '/admin',
  //           path: '/main/ERP/Personal/RegistroPersonal',
  //           exact: false,
  //           component: <RegistroPersonal />,
  //         },
  //       ]
  //     },
   
  //     {
  //       name: 'Proveedores',
  //       path: '/main/account',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nuevo Proveedor',
  //           layout: '/admin',
  //           path: '/main/ERP/Proveedor/NuevoProveedor',
  //           exact: false,
  //           component: <NuevoProveedor />,
  //         }, {
  //           name: 'Registro de Proveedores',
  //           layout: '/admin',
  //           path: '/main/ERP/Proveedor/RegistroProveedores',
  //           exact: false,
  //           component: <RegistroProveedor />,
  //         },
  //       ]
  //     },
  //     {
  //       name: 'Compras',
  //       path: '/main/ERP/Compras',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nueva Compra',
  //           layout: '/admin',
  //           path: '/main/ERP/Compras/NuevaCompra',
  //           exact: false,
  //           component: <NuevaCompra />,
  //         }, {
  //           name: 'Registro de Compras',
  //           layout: '/admin',
  //           path: '/main/ERP/Compras/RegistrosCompras',
  //           exact: false,
  //           component: <RegistrosCompras />,
  //         },
  //       ]
  //     },
  //     {
  //       name: 'Ventas',
  //       path: '/main/ERP/Ventas',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nueva Venta',
  //           layout: '/admin',
  //           path: '/main/ERP/Ventas/NuevaVenta',
  //           exact: false,
  //           component: <NuevaVenta />,
  //         }, {
  //           name: 'Registro de Ventas',
  //           layout: '/admin',
  //           path: '/main/ERP/Ventas/RegistrosVentas',
  //           exact: false,
  //           component: <RegistrosVentas />,
  //         },
  //       ]
  //     },
    
  //     {
  //       name: 'Agenda',
  //       path: '/main/ERP/AgendaActividades',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nueva Actividad',
  //           layout: '/admin',
  //           path: '/main/ERP/AgendaActividades/NuevaActividad',
  //           exact: false,

  //           component: <NuevaActividad />,

  //         }, {
  //           name: 'Registro de Actividades',
  //           layout: '/admin',
  //           path: '/main/ERP/AgendaActividades/RegistroActividades',
  //           exact: false,
  //           component: <RegistroActividades />,
  //         },

  //         {
  //           name: 'Galeria de Evidencias',
  //           layout: '/admin',
  //           path: '/main/ERP/AgendaActividades/Calendario',
  //           exact: false,
  //           component: <Album />,
  //         },
  //       ]
  //     },



  //     {
  //       name: 'Configuracion',
  //       path: '/main/account',
  //       collapse: true,
  //       items: [
        

  //         {
  //           name: 'Carga Inicial',
  //           layout: '/admin',
  //           path: '/main/ERP/Configuracion/CargaInicial',
  //           exact: false,
  //           component: <CargaInicial />,
  //         }, {
  //           name: 'Ajuste Positivo',
  //           layout: '/admin',
  //           path: '/main/ERP/Configuracion/AjustePositivo',
  //           exact: false,

  //           component: <AjustePositivo />,
  //         }, {
  //           name: 'Ajuste Negativo',
  //           layout: '/admin',
  //           path: '/main/ERP/Configuracion/AjusteNegativo',
  //           exact: false,
  //           component: <AjusteNegativo />,
  //         },
  //       ]
  //     },
  //   ],


  // },
  // --- Authentication ---
  // {
  //   name: 'Autentificate',
  //   path: '/auth',
  //   icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Inicia Sesion',
  //       path: '/sign-in',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Default',
  //           layout: '/auth',
  //           path: '/sign-in/default',
  //           component: <SignInDefault />,
  //         },
       
  //       ],
  //     },
    
  //   ],
  // },
];

export default routes;